import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/axios";

const EmployeeView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const response = await api.get(`/employees/${id}`);
        setEmployee(response.data);
      } catch (err) {
        console.error("Error fetching employee details:", err);
        alert("Failed to load employee details");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployee();
  }, [id]);

  if (loading) return (
    <div className="container mt-4 text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-2">Loading employee profile...</p>
    </div>
  );

  if (!employee) return (
    <div className="container mt-4">
      <div className="alert alert-warning">Employee not found.</div>
      <button className="btn btn-secondary" onClick={() => navigate("/dashboard/employees/list")}>
        Back to List
      </button>
    </div>
  );

  const fullName = `${employee.first_name || ''} ${employee.middle_name || ''} ${employee.last_name || ''}`.trim();

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-primary">Employee Profile</h2>
        <div>
          <button 
            className="btn btn-outline-primary me-2" 
            onClick={() => navigate(`/dashboard/employees/list`)}
          >
            Back to List
          </button>
        </div>
      </div>

      <div className="row">
        {/* Profile Card */}
        <div className="col-md-4">
          <div className="card shadow-sm border-0 text-center p-4">
            <div 
              className="mx-auto mb-3 shadow-sm"
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                backgroundColor: employee.profile_color || '#32CD32',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '48px',
                color: '#fff',
                border: '4px solid #fff'
              }}
            >
              {employee.first_name ? employee.first_name[0].toUpperCase() : '?'}
            </div>
            <h4 className="mb-1">{fullName}</h4>
            <p className="text-muted">{employee.education || 'No Education Data'}</p>
            <div className="d-grid gap-2 mt-3">
              <button className="btn btn-sm btn-primary">Edit Profile</button>
            </div>
          </div>
        </div>

        {/* Details Card */}
        <div className="col-md-8">
          <div className="card shadow-sm border-0 p-4">
            <h5 className="border-bottom pb-2 mb-3">Personal Details</h5>
            <div className="row g-3">
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Father's Name</label>
                <span>{employee.father_name || '—'}</span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Gender</label>
                <span className={`badge ${employee.gender === 'Male' ? 'bg-info' : employee.gender === 'Female' ? 'bg-warning' : 'bg-secondary'}`}>
                  {employee.gender || '—'}
                </span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Age</label>
                <span>{employee.age || '—'} years</span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Blood Group</label>
                <span className="text-danger font-weight-bold">{employee.blood_group || '—'}</span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Date of Birth</label>
                <span>{employee.date_of_birth || '—'}</span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Education</label>
                <span>{employee.education || '—'}</span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Height</label>
                <span>{employee.height ? `${employee.height} cm` : '—'}</span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Weight</label>
                <span>{employee.weight ? `${employee.weight} kg` : '—'}</span>
              </div>
              <div className="col-6 col-sm-4">
                <label className="text-muted small d-block">Employee ID</label>
                <span className="badge bg-dark">#{employee.id}</span>
              </div>
            </div>

            <h5 className="border-bottom pb-2 mt-4 mb-3">System Metadata</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="text-muted small d-block">Created At</label>
                <span className="small">{employee.created_at ? new Date(employee.created_at).toLocaleString() : '—'}</span>
              </div>
              <div className="col-md-6">
                <label className="text-muted small d-block">Last Updated</label>
                <span className="small">{employee.updated_at ? new Date(employee.updated_at).toLocaleString() : '—'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeView;
